<ng-container *transloco="let t">
  @if (showDatasourceChip) {
    <div class="datasource-chip">
      <mat-chip-listbox>
        <mat-chip-option (click)="showDatasourceSearch()" [disabled]="disabled">
          <div>
            <mat-icon
              [svgIcon]="iconFor(value)"
              [matTooltip]="
                t('widgets.datasource-tooltip', {
                  datasource: datasourceDisplayName,
                  count: (dataSourceDocumentCount | humanizeInt: 1 : 1000),
                })
              "
              [matTooltipDisabled]="!compact"
            ></mat-icon>
          </div>
          @if (!compact) {
            <div class="datasource-display-name">
              <ng-container *appMiddleEllipsize="datasourceDisplayName"></ng-container>
            </div>
            &nbsp;
            @if (value) {
              <small class="datasource-docs">
                |
                {{
                  t('widgets.numberof-docs', {
                    count: (dataSourceDocumentCount | humanizeInt: 1 : 1000),
                  })
                }}</small
              >
            }
          }
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  }
  @if (!showDatasourceChip) {
    <div [ngClass]="matInputClasses">
      <mat-form-field>
        <span matPrefix><mat-icon>search</mat-icon></span>
        <input
          #elementDatasourceInput
          type="text"
          matInput
          [placeholder]="t('widgets.change-data-source')"
          [formControl]="datasourceAc.control"
          [(ngModel)]="selectedDatasource"
          [matAutocomplete]="elementSelectedDatasource"
          (input)="updateDataSources()"
          (blur)="resetDataSource($event)"
        />
        <mat-autocomplete
          #elementSelectedDatasource="matAutocomplete"
          (optionSelected)="selectDatasource($event.option.value)"
          [panelWidth]="overrideInternalChipLogic ? '300px' : '450px'"
        >
          @for (item of datasourceAc.observable | async; track item) {
            <div [matTooltip]="datasourceProps[item.value.id]?.tooltip">
              <mat-option
                [value]="item"
                [disabled]="!!datasourceProps[item.value.id]?.disabled"
                [class.picker-option--selected]="value === item?.value"
                (mousedown)="$event.preventDefault()"
              >
                <div class="picker-option">
                  @if (!overrideInternalChipLogic) {
                    <mat-icon [svgIcon]="iconFor(item.value)"></mat-icon>
                  } @else {
                    <xi-icon
                      [icon]="iconFor(item.value)"
                      iconSize="medium"
                      class="kxi-padding-horizontal-small"
                    ></xi-icon>
                  }
                  {{ item.display | truncate: 30 }} |
                  <small>
                    {{
                      t('widgets.numberof-docs', {
                        count: (item.value.documentCount | humanizeInt: 1 : 1000),
                      })
                    }}
                  </small>
                  @if (value === item?.value) {
                    <xi-icon
                      class="picker-option__selected-icon"
                      icon="circle_check_filled"
                      color="CX"
                    ></xi-icon>
                  }
                </div>
              </mat-option>
            </div>
          }
        </mat-autocomplete>
        <button
          matSuffix
          mat-icon-button
          (mousedown)="$event.preventDefault()"
          (click)="clearSelectedDatasource()"
          class="data-source-chooser__clear-search"
        >
          <xi-icon icon="cancel" iconSize="small"></xi-icon>
        </button>
        @if (datasourceAc.inProgress) {
          <mat-spinner matSuffix diameter="24"></mat-spinner>
        }
      </mat-form-field>
    </div>
  }
</ng-container>
